

































import { Component, Vue } from 'vue-property-decorator'
import usersApi from '@/api/users'
import {
    IChangeUserPasswordPopup,
    IUserGeneralAndContactInfoSection,
    UserProfileDto
} from "@/global";
import appUtils from '@/plugins/app-utils'
import * as enums from "@/global-enum";
import Helpers from "@/helpers";
import UserGeneralAndContactInfoSection from "@/views/user/UserGeneralAndContactInfoSection.vue";
import ChangeUserPasswordPopup from "@/components/ChangeUserPasswordPopup.vue";
import {AuthModule} from "@/store/modules/auth";

@Component({
    components: {
        UserGeneralAndContactInfoSection, ChangeUserPasswordPopup
    }
})
export default class UserProfile extends Vue {
    isLoading = true;
    isButtonsDisabled = false;
    user: UserProfileDto | null = null;

    mounted() {
        const thisInst = this;
        this.initData(() => {
            thisInst.$nextTick(async () => {
                const generalAndContactInfoSection = thisInst.$refs.generalAndContactInfoSection as unknown as IUserGeneralAndContactInfoSection;
                await generalAndContactInfoSection.afterDataInit();

                this.isLoading = false;
            });
        });
    }

    // computed
    get validateForm(): boolean {
        return !this.veeErrors.any();
    }

    get isAdminEdit() {
        const userInfo = AuthModule.obtainUserInfo();
        return this.$helpers.isExists(userInfo) &&
            this.$helpers.anyInArray(userInfo!.accesses, x =>
                x.type === enums.UserAccessType_SystemAdmin ||
                x.type === enums.UserAccessType_Users ||
                x.type === enums.UserAccessType_KnowledgeBase);
    }

    // methods
    validateState(ref: string) {
        if (this.veeFields[ref] &&
            (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
            return !this.veeErrors.has(ref);
        }

        return null
    }

    showError(errorMessage?: string) {
        this.$bvToast.toast(errorMessage || "Спробуйте пізніше", {
            title: "Помилка",
            variant: "danger"
        })
    }

    initData(afterUserInit: () => void) {
        this.isLoading = true;

        usersApi.getProfile(((u) => {
            this.user = u;

            afterUserInit();
        }), this.showError);
    }

    async changePassword() {
        const changeUserPasswordPopup = this.$refs.changeUserPasswordPopup as unknown as IChangeUserPasswordPopup;
        changeUserPasswordPopup.openChangeUserPasswordPopup();
    }

    async saveChanges() {
        this.isButtonsDisabled = true;

        const generalAndContactInfoSection = this.$refs.generalAndContactInfoSection as unknown as IUserGeneralAndContactInfoSection;

        let isValid = true;

        if (!await generalAndContactInfoSection.validateAll()) {
            isValid = false;
        }

        if (!await this.$validator.validateAll()) {
            isValid = false;
        }

        if (isValid) {
            usersApi.updateProfile(this.user!, (data) => {
                if (data.success){
                    if (data.isAnyChanges) {
                        this.$bvToast.toast("Зміни успішно збережені", {
                            title: "Успіх",
                            variant: "success"
                        });
                    } else {
                        this.$bvToast.toast("Зміни не потрібні, інформація в актуальному стані", {
                            title: "Повідомлення",
                            variant: "info"
                        });
                    }
                } else {
                    this.showError()
                }

                this.isButtonsDisabled = false;
            }, errorMessage => {
                this.isButtonsDisabled = false;

                this.showError(errorMessage)
            });
        } else {
            this.isButtonsDisabled = false;
        }
    }
}
